import Text from '@zenbusiness/common-components/Text';

import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Grid from '@mui/material/Grid';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

function getBackgroundColorForStep(step, currentStep, currentProgress, theme) {
  if (step === currentStep) {
    return theme.palette.focus90.main;
  } if (step < currentProgress) {
    return theme.palette.growth20.main;
  } if (step === currentProgress) {
    return theme.palette.focus20.main;
  }
  return theme.palette.focus90.main;
}
export const StatusGrid = superstyled({
  tag: Grid,
  propsNeeded: ['step', 'currentStep', 'currentProgress'],
  styles: ({
    theme, step, currentStep, currentProgress
  }) => ({
    backgroundColor: getBackgroundColorForStep(step, currentStep, currentProgress, theme),
    alignItems: 'center',
    width: '100%',
    '& .MuiGrid-root:first-of-type': {
      borderRadius: '1rem 0 0 1rem',
      marginRight: '2px'
    },
    '& .MuiGrid-root:last-of-type': {
      borderRadius: '0 1rem 1rem 0'
    },
    '& .MuiGrid-root:not(:first-of-type):not(:last-of-type)': {
      borderRadius: 0,
      marginRight: '2px'
    },
    height: '0.5rem'
  })
});
export const Container = superstyled({
  tag: Box,
  styles: {
    alignItems: 'center',
    width: '100%',
    '& .MuiGrid-root:first-of-type': {
      borderRadius: '1rem 0 0 1rem',
      marginRight: '2px'
    },
    '& .MuiGrid-root:last-of-type': {
      borderRadius: '0 1rem 1rem 0'
    },
    '& .MuiGrid-root:not(:first-of-type):not(:last-of-type)': {
      borderRadius: 0,
      marginRight: '2px'
    }
  }
});
export const Button = superstyled({
  tag: ButtonBase,
  styles: {
    display: 'flex',
    width: '100%',
    height: '100%'
  }
});

export const CurrentProgressText = superstyled({
  tag: Text,
  styles: ({ theme }) => ({
    whiteSpace: 'nowrap',
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      '&.MuiTypography-root': {
        marginLeft: '1rem'
      }
    }
  })
});
